import React, { useEffect, useRef } from 'react';
import * as styles from '../styles/slider.module.scss';

interface Props {
  visible?: boolean;
  inline?: boolean;
  min?: number;
  max?: number;
  step?: number;
  defaultValue?: number;
  id?: string;
  className?: string;
  ignoreId?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onOutsideClick: () => void;
}

const Slider: React.FC<Props> = ({
  visible = true,
  inline = false,
  min = 0,
  max = 1,
  defaultValue = 1,
  step = 0.01,
  id = 'slider-control',
  className,
  ignoreId,
  onChange,
  onOutsideClick,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const listeningRef = useRef(false);
  const visibleRef = useRef(visible);
  const ignoreIdRef = useRef(ignoreId);

  useEffect(() => {
    visibleRef.current = visible;
  }, [visible]);

  useEffect(() => {
    ignoreIdRef.current = ignoreId;
  }, [ignoreId]);

  useEffect(() => {
    if (listeningRef.current) {
      return;
    }

    listeningRef.current = true;

    const events = [`click`, `touchstart`] as const;

    // FIXME take a closer look at this
    const handler = (e: MouseEvent | TouchEvent) => {
      // If the element is not visible, just ignore
      if (!visibleRef.current) return;

      const target = e.target as HTMLElement | undefined;

      if (
        target?.id !== ignoreIdRef.current &&
        !containerRef.current?.contains(target!)
      ) {
        // if (!containerRef.current?.contains(e.target)) {
        // If we've clicked anywhere except the ignoreId element
        // fire the onOutsideClick() callback
        onOutsideClick();
      }
    };

    events.forEach((name) => {
      document.addEventListener(name, handler);
    });

    return () => {
      events.forEach((name) => {
        document.removeEventListener(name, handler);
      });
    };
  }, [onOutsideClick]);

  const input = (
    <input
      type='range'
      id={id}
      min={min}
      max={max}
      step={step}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );

  if (inline) {
    return (
      <div className={className} ref={containerRef}>
        {input}
      </div>
    );
  }

  return visible ? (
    <div
      className={[styles.slider_container, className].filter(Boolean).join(' ')}
      ref={containerRef}
    >
      {input}
    </div>
  ) : (
    <div></div>
  );
};

export default Slider;
